import avatar1 from '../../Assets/avatar1.svg';

const TestimonialData = [
    {
        id: 1,
        avatar: avatar1,
        name: 'Martin Lee',
        company: 'UAE',
        review: 'Sahed, your work is truly outstanding! You understood my expectations perfectly and delivered exactly what I needed. Highly professional and talented.',
    },
    {
        id: 2,
        avatar: avatar1,
        name: 'MD Abdullah Partho',
        company: 'Masrsation Company - UK',
        review: 'Brother, you made our HRM application extremely smooth and fast. Your dedication makes you my first priority for any project. Excellent work!',
    },
    {
        id: 3,
        avatar: avatar1,
        name: 'Haris Ahmed',
        company: 'Exinstore - Pakistan',
        review: 'Sahed is a very talented and experienced developer. Great overall communication and prompt delivery. Definitely will work with him again.',
    },
    {
        id: 4,
        avatar: avatar1,
        name: 'Imam Hossain',
        company: 'Criptoluxor - Australia',
        review: 'Sahed bro developed every functionality and logic in an optimized way. Very hardworking, neat, and clean work. Fully satisfied with the results.',
    },
    {
        id: 5,
        avatar: avatar1,
        name: 'Shahriar Rahman',
        company: 'Sisfarma Company',
        review: 'Without Sahed, no one could have handled our POS application’s complex tasks so well. I really appreciate his quality work and support. Looking forward to more projects together.',
    },

    {
        id: 6,
        avatar: avatar1,
        name: 'Ebohne Hemiah',
        company: 'Safety Tech - Nigeria',
        review: 'Sahed did a great job for me. He understood my expectations perfectly and delivered exactly what I needed. Truly impressive work!',
    },
];

export default TestimonialData;
